/**
* @file 文章内容
* @author Ice(chenzhouji@baidu.com)
*/
import _ from 'lodash';
import React, {FunctionComponent} from 'react';
import {createTOCItems} from '@/utils';

import Breadcrumb from '../Breadcrumb';
import TOC from './TOC';
import PostTurner from './PostTurner';
import PostBody from './PostBody';

type PostProps = {
    post: any
    location: any
    prev: PostTurnerProps
    next: PostTurnerProps
    downloadHref?: string
    lang?: string
    breadcrumb?: any,
    template?: string
};

const Post: FunctionComponent<PostProps> = props => {
    const {post, prev, next, downloadHref, lang, breadcrumb, location, template = 'default'} = props;
    const {
        fields: {title, date},
        headings,
        html
    } = post;

    const pickedHeading = _.filter(headings, ({depth}) => depth > 1);

    return (
        <div className="post-wrapper">
            {breadcrumb ? <Breadcrumb items={breadcrumb} /> : null}
            <TOC items={createTOCItems(pickedHeading)} defaultHash={location.hash} template={template} />
            <PostBody title={title} date={date} downloadHref={downloadHref} content={html} lang={lang || 'zh'} template={template} />
            <div className="post-turner-wrapper">
                <PostTurner direction="prev" {...prev} lang={lang || 'zh'} />
                <PostTurner direction="next" {...next} lang={lang || 'zh'} />
            </div>
        </div>
    );
};

export default Post;
